<template>
  <div class="qui-sommes-nous">
    <div class="title">Qui sommes-nous?</div>
    <div class="tab-group">
          <button class="button" @click="openExternalLink('ifoam')">
            <div class="button-text">IFOAM</div>
          </button>
          <button class="button" @click="openExternalLink('biofach')">
            <div class="button-text">BIOFACH</div>
          </button>
    </div>
    <p class="description">
      Le Syndicat Malgache de l&#39;Agriculture Biologique SYMABIO a été créé en mars 2011 à l&#39;initiative d&#39;opérateurs conscients del&#39;enjeu porté par la filière au plan économique, social et environnemental et de la nécessité de se structurer en groupement pour sensibiliser l&#39;opinion et les autorités dans la promotion de l&#39;agriculture biologique.
      <br />
      <br />
      Le syndicat compte une trentaine de membres exerçant des activités dans la filière bio et disposant de certificats de conformité de leurs produits biologiques. Le réseau compte 5000 partenaires producteurs en milieu rural localisés dans différentes régions de Madagascar. Les opérations de cueillette constituent aussi une source de revenu pour d&#39;innombrables villageois dans les zones répertoriées BIO.
    </p>
    <router-link to='/reglement'>
      <button class="text-button">
        <div class="text-btn">Règlement en vigueur</div>
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "QuiSommeNous",
  methods: {
    openExternalLink(type) {
      const links = {
        'ifoam': 'https://www.ifoam.bio/',
        'biofach': 'https://www.biofach.de/en'
      };
      
      const url = links[type];
      if (url) {
        window.open(url, '_blank');
      }
    }
  }
};
</script>

<style>
.qui-sommes-nous {
  /* height: 403px; */
  /* left: 295px; */
  /* position: absolute; */
  /* top: 303px; */
  width: 32vw;
}
.qui-sommes-nous .title {
  color: #000000;
  font-family: "Bw Modelica SS02";
  font-size: 28px;
  font-weight: 500;
  /* left: 0; */
  letter-spacing: 0;
  line-height: 36px;
  padding: 48px 0px 24px 0px;
  /* position: absolute; */
  /* top: 0; */
  white-space: nowrap;
}
.qui-sommes-nous .tab-group {
  align-items: flex-start;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px 4px;
  padding: 0px 0px 32px 0px;
  /* left: 295px; */
  /* position: absolute; */
  /* top: 352px; */
}

.qui-sommes-nous .button {
  all: unset;
  align-items: center;
  background-color: #163518;
  border-radius: 100px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  gap: 10px;
  justify-content: center;
  padding: 4px 12px 0px 12px;
  height: 32px;
  transition: all 0.3s ease;
  /* position: relative; */
}

.qui-sommes-nous .button:hover {
  background-color: #1e4220;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(22, 53, 24, 0.2);
}

.qui-sommes-nous .button-text {
  color: #ffffff;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  /* margin-top: -1.00px; */
  position: relative;
  white-space: nowrap;
  width: fit-content;
}


.qui-sommes-nous .description {
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 300;
  padding-left: 12px;
  /* left: 0; */
  letter-spacing: 0;
  line-height: 20px;
  /* position: absolute; */
  /* top: 123px; */
  /* width: 367px; */
}
.qui-sommes-nous .text-button{
  all: unset;
  border-radius: 100px;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
  height: 58px;
  width: 296px;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  background-color:unset;
  border: 1px solid #16351840;
  margin: 24px 0px;
}
.qui-sommes-nous .text-btn {
  color: #163518;
  font-family: "Mona-Sans", Helvetica;
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

@media (max-width:1200px){
  .qui-sommes-nous {
    width: 100%;
  }
}
</style>